import { render, staticRenderFns } from "./farm_list.vue?vue&type=template&id=19d1e2aa&scoped=true&"
import script from "./farm_list.vue?vue&type=script&lang=js&"
export * from "./farm_list.vue?vue&type=script&lang=js&"
import style0 from "./farm_list.vue?vue&type=style&index=0&id=19d1e2aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d1e2aa",
  null
  
)

export default component.exports